var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_950_17484)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.37188 0 0 5.37188 0 12C0 18.6281 5.37188 24 12 24C18.6281 24 24 18.6281 24 12C24 5.37188 18.6281 0 12 0ZM19.4906 19.4859C18.5156 20.4609 17.3859 21.225 16.125 21.7547C14.8219 22.3078 13.4344 22.5844 12 22.5844C10.5703 22.5844 9.18281 22.3031 7.875 21.7547C6.61406 21.2203 5.47969 20.4563 4.50937 19.4859C3.53437 18.5109 2.77031 17.3812 2.24063 16.1203C1.6875 14.8172 1.40625 13.4297 1.40625 12C1.40625 10.5703 1.6875 9.18281 2.23594 7.875C2.77031 6.61406 3.53437 5.47969 4.50469 4.50937C5.48438 3.53437 6.61406 2.77031 7.875 2.23594C9.18281 1.6875 10.5703 1.40625 12 1.40625C13.4297 1.40625 14.8172 1.6875 16.125 2.23594C17.3859 2.77031 18.5203 3.53438 19.4906 4.50469C20.4656 5.47969 21.2297 6.60938 21.7594 7.87031C22.3125 9.17344 22.5891 10.5609 22.5891 11.9953C22.5891 13.425 22.3078 14.8125 21.7594 16.1203C21.225 17.3812 20.4609 18.5156 19.4906 19.4859Z",
    fill: "#052850"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5844 7.90762C14.0672 7.90762 14.5828 8.05762 14.5828 8.05762L14.8922 6.22012C14.8922 6.22012 14.236 5.99512 12.6703 5.99512C11.7094 5.99512 11.1516 6.36074 10.7438 6.89981C10.3594 7.41074 10.3453 8.23105 10.3453 8.76074V9.96543H9.10315V11.7607H10.3453V17.9951H12.6703V11.7607H14.5125L14.6485 9.96543H12.6703V8.56387C12.6703 8.08106 13.1016 7.90762 13.5844 7.90762Z",
    fill: "#052850"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_950_17484"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook_icon.a5617d5ad1501e3cd22de4a5b1743709.svg";
export { ForwardRef as ReactComponent };